/**
 * Dual upholstery template for configurator
 */

import { ConfiguratorConfig } from '../types';
import translationInstance from '../utils/translations';

export const createDualTemplate = (modelId: string): ConfiguratorConfig => {
  const t = translationInstance.t.bind(translationInstance);


  return {
    viewer: {
      modelId: modelId,
      background: {
        color: [
          0.91015625,
          0.91015625,
          0.91015625
        ]
      },
      defaultActions: []
    },
    configurator: {
      options: [
        {
          _id: "section-configurations",
          controlType: "section",
          name: t('virtenzo.configuration.section_configurations'),
          headlineText: t('virtenzo.configurator.section_configurations'),
          actions: [],
          groups: "Configurations",
          classes: [
            "virtenzo-panel-section",
            "section-configurations"
          ],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.section_configurations'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            {
              _id: "8004c9f8-1534-4601-808b-bae614e372f2",
              actions: [
                {
                  _id: "9a87ee91-aa42-4d8b-a61b-b3db44d4ed46",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "wood_Beech Taupe_0",
                  materialName: "Beech Taupe"
                },
                {
                  _id: "1ac0fff1-e204-4306-8696-913acbbf7f58",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_top_Piano_13_0",
                  materialName: "Piano_13"
                },
                {
                  _id: "be804759-3f15-4cc0-aa55-fa5152f9ee52",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_bottom_Mag 7026_0",
                  materialName: "Mag 7026"
                }
              ],
              controlType: "button",
              name: t('virtenzo.configuration') + " 1",
              classes: [
                "virtenzo-panel-button", 'virtenzo-configuration-1'
              ],
              href: "",
              groups: "Wood"
            },
            {
              _id: "b221457f-b902-4214-a89c-13f3d9bcbeff",
              actions: [
                {
                  _id: "9be1b63c-5dfb-4965-b19c-65663a3240fa",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "wood_Beech Taupe_0",
                  materialName: "American Walnut Natural Oil"
                },
                {
                  _id: "809010be-dee3-4279-87b0-064c6e9caa11",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_bottom_Mag 7026_0",
                  materialName: "Leather black"
                },
                {
                  _id: "553ebec1-72ff-4ba1-8bd1-dd7a5c6f6459",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_top_Piano_13_0",
                  materialName: "Home_22"
                }
              ],
              controlType: "button",
              name: t('virtenzo.configuration') + " 2",
              classes: [
                "virtenzo-panel-button",
                'virtenzo-configuration-2'
              ],
              href: "",
              groups: "Wood"
            },
            {
              _id: "b6ea34de-0c42-4c51-b99e-e99fda5e41ba",
              actions: [
                {
                  _id: "c6481e69-07b0-4b5a-a325-854023a2a459",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "wood_Beech Taupe_0",
                  materialName: "Oak Oil Light Grey"
                },
                {
                  _id: "11cf1fea-9a80-4bf9-9d7a-9a518144f835",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_top_Piano_13_0",
                  materialName: "Tama_01"
                },
                {
                  _id: "2a2b3d1b-2fc6-473d-88ba-54bb58c092af",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_bottom_Mag 7026_0",
                  materialName: "Leather Limestone"
                }
              ],
              controlType: "button",
              name: t('virtenzo.configuration') + 3,
              classes: [
                "virtenzo-panel-button",
                'virtenzo-configuration-3'
              ],
              href: "",
              groups: "Wood"
            },
            {
              _id: "0c167087-710e-4cbd-b509-ea185d0829e7",
              actions: [
                {
                  _id: "c3db8e5f-0c7d-49d6-a8cd-a1b6be178540",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "wood_Beech Taupe_0",
                  materialName: "Oak Oil Bianco"
                },
                {
                  _id: "092a5396-8302-4432-8663-64ef3decd9ea",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_top_Piano_13_0",
                  materialName: "Tis 04"
                },
                {
                  _id: "ea978965-8a50-4091-aebe-90907d722a68",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_bottom_Mag 7026_0",
                  materialName: "Leather caffee latte"
                }
              ],
              controlType: "button",
              name: t('virtenzo.configuration') + " 4",
              classes: [
                "virtenzo-panel-button",
                'virtenzo-configuration-4'
              ],
              href: "",
              groups: "Wood"
            },
            {
              _id: "f2d0aa98-35ad-421d-8ae6-1611d08100b9",
              actions: [
                {
                  _id: "bd19649e-d950-4315-82a8-b9884393aa0b",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "wood_Beech Taupe_0",
                  materialName: "Oak Carbon"
                },
                {
                  _id: "6ea62921-ef6b-41eb-9722-45a3f8516f8d",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_top_Piano_13_0",
                  materialName: "Haga 900"
                },
                {
                  _id: "8c0db39a-4135-4c73-a28c-220b22752da3",
                  functionName: "setMaterialByObjectNameMaterialName",
                  name: "fabric_bottom_Mag 7026_0",
                  materialName: "Leather Drak graphite"
                }
              ],
              controlType: "button",
              name: t('virtenzo.configuration') + " 5",
              classes: [
                "virtenzo-panel-button",
                'virtenzo-configuration-5'
              ],
              href: "",
              groups: "Wood"
            },

          ]
        },
        {
          _id: '5187435b-4144-4588-940c-section',
          actions: [],
          controlType: 'section',
          name: t('virtenzo.configurator.section_upholstery'),
          classes: ['virtenzo-panel-section'],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.section_upholstery_backrest'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            {
              _id: 'leather-section',
              actions: [],
              controlType: 'section',
              name: t('virtenzo.configurator.leather'),
              classes: ['virtenzo-panel-section', 'leather-section', 'upholstery-section'],
              subOptions: [
                {
                  _id: '1435b9b6-12a0-468f-b4e0-30e41e09f88c',
                  actions: [
                    {
                      _id: '468cff77-52f5-4faf-8d4b-20f3c329639e',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Leather black',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_BACKREST',
                      value: 'LEATHER',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Leather Black',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_black.jpg',
                  name: 'Leather Black',
                  text: 'Leather Black',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '193a517a-08f0-40af-8b48-3bc7a3718af2',
                  actions: [
                    {
                      _id: '65192adc-242f-4636-90a5-ef471bbb8480',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Leather smog',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_BACKREST',
                      value: 'LEATHER',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Leather Smog',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_smog.jpg',
                  name: 'Leather Smog',
                  text: 'Leather Smog',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'eec7833e-ed29-4bd1-8d6b-6fce3730dc9e',
                  actions: [
                    {
                      _id: 'e8bd6736-729c-49a7-a9c4-45e0c35a8fe5',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Leather caffee latte',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_BACKREST',
                      value: 'LEATHER',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Leather Caffee Latte',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_caffee_latte.jpg',
                  name: 'Leather Caffee Latte',
                  text: 'Leather Caffee Latte',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
              ],
            },
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.fabrics_group_a'),
              classes: ['virtenzo-panel-section-headline'],
              href: '',
            },
            {
              _id: 'fabrics-group-a-section',
              actions: [],
              controlType: 'section',
              name: t('virtenzo.configurator.fabrics_group_a'),
              classes: ['virtenzo-panel-section', 'fabrics-group-a-section', 'upholstery-section'],
              subOptions: [
                {
                  _id: 'c62eb2f1-df77-40c8-a79a-eb51e05508c8',
                  actions: [
                    {
                      _id: '8df7e665-24cf-4f25-aac8-745d63a7e52f',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Bel Sand',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Bel Sand',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/bel_sand.jpg',
                  name: 'Bel Sand',
                  text: 'Bel Sand',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '1b06c328-be87-42df-bbf9-1449a51874ba',
                  actions: [
                    {
                      _id: 'bcd8561f-fa4b-4756-94c1-b4e3d3795e69',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Dig 6009',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Dig 6009',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/dig_6009.jpg',
                  name: 'Dig 6009',
                  text: 'Dig 6009',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '5c4e7a83-f8c9-4298-864d-551c8de756af',
                  actions: [
                    {
                      _id: '3c1053fe-9e73-4e1d-b7f8-54af1b6a547d',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Velvet 2282',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Velvet 2282',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/velvet_2282.jpg',
                  name: 'Velvet 2282',
                  text: 'Velvet 2282',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'a6a65df1-21eb-463f-b83e-4cb0ddb2f480',
                  actions: [
                    {
                      _id: '52a15ded-f1d3-4c97-999f-c4e27308aa8d',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Pino 16',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Pino 16',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/pino_16.jpg',
                  name: 'Pino 16',
                  text: 'Pino 16',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '4a64162d-515b-4aa5-b880-449d4e03d5d5',
                  actions: [
                    {
                      _id: '8160bd07-3b5f-4652-aa46-2ee3680a0eb1',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Kia 700',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Kia 700',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/kia_700.jpg',
                  name: 'Kia 700',
                  text: 'Kia 700',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '2aa722cf-5318-4e9c-bf4f-c6cdcdb2a916',
                  actions: [
                    {
                      _id: '9f930271-7772-453e-a5ba-17e450db58fc',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'SC Sand',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_A',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'SC Sand',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/sc_sand.jpg',
                  name: 'SC Sand',
                  text: 'SC Sand',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
              ],
            },
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.fabrics_group_b'),
              classes: ['virtenzo-panel-section-headline'],
              href: '',
            },
            {
              _id: 'fabrics-group-b-section',
              actions: [],
              controlType: 'section',
              name: t('virtenzo.configurator.fabrics_group_b'),
              classes: ['virtenzo-panel-section', 'fabrics-group-b-section', 'upholstery-section'],
              subOptions: [
                {
                  _id: '76c74f0c-fa21-49b3-8052-fdc941c8d741',
                  actions: [
                    {
                      _id: '37ad4d01-3aa0-4081-a594-d51d04d05c9f',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Ines 13',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Ines 13 Gargoyle',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/ines_13.jpg',
                  name: 'Ines 13 Gargoyle',
                  text: 'Ines 13 Gargoyle',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'e56565f5-6e3e-4bd6-b0f3-fcbe7562de11',
                  actions: [
                    {
                      _id: '1b173966-9c51-4127-92df-14cd4feb7c47',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Rae 05',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Rae 05',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/rae_05.jpg',
                  name: 'Rae 05',
                  text: 'Rae 05',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '229f5507-b264-4b86-af5c-3d9d4d246f4e',
                  actions: [
                    {
                      _id: '850ed020-eee8-4a35-9c7f-206b60dbb627',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Haga 900',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Haga 900',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/haga_900.jpg',
                  name: 'Haga 900',
                  text: 'Haga 900',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'cf2408ad-fb73-4555-87b5-7a6e864291e2',
                  actions: [
                    {
                      _id: 'c638367d-a830-4750-bf38-f91285c360d8',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Home 21',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Home 21 Beaver',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/home_21.jpg',
                  name: 'Home 21 Beaver',
                  text: 'Home 21 Beaver',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '24a335c6-40b1-42ea-be4a-1067d6c6327b',
                  actions: [
                    {
                      _id: '6d969db6-d9ca-4e0d-beb8-e1b7ed2a7095',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Home 07 Hemp',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Home 07 Hemp',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/home_07_hemp.jpg',
                  name: 'Home 07 Hemp',
                  text: 'Home 07 Hemp',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '76c74f0c-fa21-49b3-8052-fdc941c8d742',
                  actions: [
                    {
                      _id: '37ad4d01-3aa0-4081-a594-d51d04d05c9e',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Haga 901',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_B',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Haga 901',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/haga_901.jpg',
                  name: 'Haga 901',
                  text: 'Haga 901',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                }

              ],
            },
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.fabrics_group_c'),
              classes: ['virtenzo-panel-section-headline'],
              href: '',
            },
            {
              _id: 'fabrics-group-c-section',
              actions: [],
              controlType: 'section',
              name: t('virtenzo.configurator.fabrics_group_c'),
              classes: ['virtenzo-panel-section', 'fabrics-group-c-section', 'upholstery-section'],
              subOptions: [
                {
                  _id: '42c48c90-eec8-435f-91e6-83146c7b6425',
                  actions: [
                    {
                      _id: 'fab35a4b-48ad-4647-8600-c80b1ccbfb7f',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Tis 04',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Tis 04',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tis_04.jpg',
                  name: 'Tis 04',
                  text: 'Tis 04',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '00bea6cb-8e96-463b-882d-4591723a3228',
                  actions: [
                    {
                      _id: '521e3625-3e85-4f89-85fd-598c6f720589',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Char 06',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Char 06',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/char_06.jpg',
                  name: 'Char 06',
                  text: 'Char 06',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '76d1bdd9-c15a-4a96-8072-b0db86ae71bd',
                  actions: [
                    {
                      _id: '064f6c84-25d1-45f0-951f-6e282ad66777',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Tay 05',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Tay 05',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tay_05.jpg',
                  name: 'Tay 05',
                  text: 'Tay 05',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '10137cc1-5029-46da-b8d0-2f5b339f6bd6',
                  actions: [
                    {
                      _id: 'aa7caa99-f157-4fd4-9f65-c87bcac0a714',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Cudy 01',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Cudy 01 Sezame',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/cudy_01.jpg',
                  name: 'Cudy 01 Sezame',
                  text: 'Cudy 01 Sezame',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'd648d41f-2534-4749-aae3-d41e5db58f27',
                  actions: [
                    {
                      _id: '0f4fe593-8b34-4b54-95e0-9e74bfb4c346',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Tis 05',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Tis 05',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tis_05.jpg',
                  name: 'Tis 05',
                  text: 'Tis 05',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: 'a82f73c5-9ba1-4ded-bea2-93c3f88d2d2c',
                  actions: [
                    {
                      _id: 'f91ffd68-59ce-4d5d-b56b-45269008c9c0',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Boh 800',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Boh 800',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/boh_800.jpg',
                  name: 'Boh 800',
                  text: 'Boh 800',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '03cfe2d8-ec98-4de9-b328-be6da6cfa93d',
                  actions: [
                    {
                      _id: '24419bca-2f13-44b9-a447-6a574a9610e3',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Mag 7026',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Mag 7026',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_7026.jpg',
                  name: 'Mag 7026',
                  text: 'Mag 7026',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '7476a7a2-67c1-4de3-8687-62b69c15849f',
                  actions: [
                    {
                      _id: '8e56a942-bf71-4dae-88c7-4375b88742b4',
                      functionName: 'setMaterialByObjectPrefixMaterialName',
                      prefix: 'fabric_top',
                      materialName: 'Mag 5001',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY',
                      value: 'CATEGORY_C',
                    },
                    {
                      functionName: 'setSystemVariable',
                      name: 'UPHOLSTERY_LABEL',
                      value: 'Mag 5001',
                    },
                  ],
                  controlType: 'imageButton',
                  imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_5001.jpg',
                  name: 'Mag 5001',
                  text: 'Mag 5001',
                  classes: ['virtenzo-panel-button'],
                  href: '',
                  groups: 'Upholstery',
                },
                {
                  _id: '5187435b-4144-4588-940c-section',
                  actions: [],
                  controlType: 'section',
                  name: t('virtenzo.configurator.section_upholstery'),
                  classes: ['virtenzo-panel-section'],
                  subOptions: [
                    {
                      _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
                      actions: [],
                      controlType: 'sectionHeadline',
                      name: t('virtenzo.configurator.section_upholstery_seat'),
                      classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
                      href: '',
                    },
                    {
                      _id: 'leather-section',
                      actions: [],
                      controlType: 'section',
                      name: t('virtenzo.configurator.leather'),
                      classes: ['virtenzo-panel-section', 'leather-section', 'upholstery-section'],
                      subOptions: [
                        {
                          _id: '1435b9b6-12a0-468f-b4e0-30e41e09f88c',
                          actions: [
                            {
                              _id: '468cff77-52f5-4faf-8d4b-20f3c329639e',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Leather black',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'LEATHER',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Leather Black',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_black.jpg',
                          name: 'Leather Black',
                          text: 'Leather Black',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '193a517a-08f0-40af-8b48-3bc7a3718af2',
                          actions: [
                            {
                              _id: '65192adc-242f-4636-90a5-ef471bbb8480',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Leather smog',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'LEATHER',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Leather Smog',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_smog.jpg',
                          name: 'Leather Smog',
                          text: 'Leather Smog',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'eec7833e-ed29-4bd1-8d6b-6fce3730dc9e',
                          actions: [
                            {
                              _id: 'e8bd6736-729c-49a7-a9c4-45e0c35a8fe5',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Leather caffee latte',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'LEATHER',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Leather Caffee Latte',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/leather_caffee_latte.jpg',
                          name: 'Leather Caffee Latte',
                          text: 'Leather Caffee Latte',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                      ],
                    },
                    {
                      _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
                      actions: [],
                      controlType: 'sectionHeadline',
                      name: t('virtenzo.configurator.fabrics_group_a'),
                      classes: ['virtenzo-panel-section-headline'],
                      href: '',
                    },
                    {
                      _id: 'fabrics-group-a-section',
                      actions: [],
                      controlType: 'section',
                      name: t('virtenzo.configurator.fabrics_group_a'),
                      classes: ['virtenzo-panel-section', 'fabrics-group-a-section', 'upholstery-section'],
                      subOptions: [
                        {
                          _id: 'c62eb2f1-df77-40c8-a79a-eb51e05508c8',
                          actions: [
                            {
                              _id: '8df7e665-24cf-4f25-aac8-745d63a7e52f',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Bel Sand',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Bel Sand',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/bel_sand.jpg',
                          name: 'Bel Sand',
                          text: 'Bel Sand',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '1b06c328-be87-42df-bbf9-1449a51874ba',
                          actions: [
                            {
                              _id: 'bcd8561f-fa4b-4756-94c1-b4e3d3795e69',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Dig 6009',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Dig 6009',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/dig_6009.jpg',
                          name: 'Dig 6009',
                          text: 'Dig 6009',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '5c4e7a83-f8c9-4298-864d-551c8de756af',
                          actions: [
                            {
                              _id: '3c1053fe-9e73-4e1d-b7f8-54af1b6a547d',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Velvet 2282',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Velvet 2282',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/velvet_2282.jpg',
                          name: 'Velvet 2282',
                          text: 'Velvet 2282',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'a6a65df1-21eb-463f-b83e-4cb0ddb2f480',
                          actions: [
                            {
                              _id: '52a15ded-f1d3-4c97-999f-c4e27308aa8d',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Pino 16',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Pino 16',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/pino_16.jpg',
                          name: 'Pino 16',
                          text: 'Pino 16',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '4a64162d-515b-4aa5-b880-449d4e03d5d5',
                          actions: [
                            {
                              _id: '8160bd07-3b5f-4652-aa46-2ee3680a0eb1',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Kia 700',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Kia 700',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/kia_700.jpg',
                          name: 'Kia 700',
                          text: 'Kia 700',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '2aa722cf-5318-4e9c-bf4f-c6cdcdb2a916',
                          actions: [
                            {
                              _id: '9f930271-7772-453e-a5ba-17e450db58fc',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'SC Sand',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_A',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'SC Sand',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/sc_sand.jpg',
                          name: 'SC Sand',
                          text: 'SC Sand',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                      ],
                    },
                    {
                      _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
                      actions: [],
                      controlType: 'sectionHeadline',
                      name: t('virtenzo.configurator.fabrics_group_b'),
                      classes: ['virtenzo-panel-section-headline'],
                      href: '',
                    },
                    {
                      _id: 'fabrics-group-b-section',
                      actions: [],
                      controlType: 'section',
                      name: t('virtenzo.configurator.fabrics_group_b'),
                      classes: ['virtenzo-panel-section', 'fabrics-group-b-section', 'upholstery-section'],
                      subOptions: [
                        {
                          _id: '76c74f0c-fa21-49b3-8052-fdc941c8d741',
                          actions: [
                            {
                              _id: '37ad4d01-3aa0-4081-a594-d51d04d05c9f',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Ines 13',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Ines 13 Gargoyle',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/ines_13.jpg',
                          name: 'Ines 13 Gargoyle',
                          text: 'Ines 13 Gargoyle',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'e56565f5-6e3e-4bd6-b0f3-fcbe7562de11',
                          actions: [
                            {
                              _id: '1b173966-9c51-4127-92df-14cd4feb7c47',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Rae 05',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Rae 05',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/rae_05.jpg',
                          name: 'Rae 05',
                          text: 'Rae 05',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '229f5507-b264-4b86-af5c-3d9d4d246f4e',
                          actions: [
                            {
                              _id: '850ed020-eee8-4a35-9c7f-206b60dbb627',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Haga 900',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Haga 900',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/haga_900.jpg',
                          name: 'Haga 900',
                          text: 'Haga 900',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'cf2408ad-fb73-4555-87b5-7a6e864291e2',
                          actions: [
                            {
                              _id: 'c638367d-a830-4750-bf38-f91285c360d8',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Home 21',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Home 21 Beaver',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/home_21.jpg',
                          name: 'Home 21 Beaver',
                          text: 'Home 21 Beaver',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '24a335c6-40b1-42ea-be4a-1067d6c6327b',
                          actions: [
                            {
                              _id: '6d969db6-d9ca-4e0d-beb8-e1b7ed2a7095',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Home 07 Hemp',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Home 07 Hemp',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/home_07_hemp.jpg',
                          name: 'Home 07 Hemp',
                          text: 'Home 07 Hemp',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '76c74f0c-fa21-49b3-8052-fdc941c8d742',
                          actions: [
                            {
                              _id: '37ad4d01-3aa0-4081-a594-d51d04d05c9e',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Haga 901',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_B',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Haga 901',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/haga_901.jpg',
                          name: 'Haga 901',
                          text: 'Haga 901',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        }

                      ],
                    },
                    {
                      _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a7',
                      actions: [],
                      controlType: 'sectionHeadline',
                      name: t('virtenzo.configurator.fabrics_group_c'),
                      classes: ['virtenzo-panel-section-headline'],
                      href: '',
                    },
                    {
                      _id: 'fabrics-group-c-section',
                      actions: [],
                      controlType: 'section',
                      name: t('virtenzo.configurator.fabrics_group_c'),
                      classes: ['virtenzo-panel-section', 'fabrics-group-c-section', 'upholstery-section'],
                      subOptions: [
                        {
                          _id: '42c48c90-eec8-435f-91e6-83146c7b6425',
                          actions: [
                            {
                              _id: 'fab35a4b-48ad-4647-8600-c80b1ccbfb7f',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Tis 04',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Tis 04',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tis_04.jpg',
                          name: 'Tis 04',
                          text: 'Tis 04',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '00bea6cb-8e96-463b-882d-4591723a3228',
                          actions: [
                            {
                              _id: '521e3625-3e85-4f89-85fd-598c6f720589',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Char 06',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Char 06',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/char_06.jpg',
                          name: 'Char 06',
                          text: 'Char 06',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '76d1bdd9-c15a-4a96-8072-b0db86ae71bd',
                          actions: [
                            {
                              _id: '064f6c84-25d1-45f0-951f-6e282ad66777',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Tay 05',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Tay 05',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tay_05.jpg',
                          name: 'Tay 05',
                          text: 'Tay 05',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '10137cc1-5029-46da-b8d0-2f5b339f6bd6',
                          actions: [
                            {
                              _id: 'aa7caa99-f157-4fd4-9f65-c87bcac0a714',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Cudy 01',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Cudy 01 Sezame',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/cudy_01.jpg',
                          name: 'Cudy 01 Sezame',
                          text: 'Cudy 01 Sezame',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'd648d41f-2534-4749-aae3-d41e5db58f27',
                          actions: [
                            {
                              _id: '0f4fe593-8b34-4b54-95e0-9e74bfb4c346',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Tis 05',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Tis 05',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/tis_05.jpg',
                          name: 'Tis 05',
                          text: 'Tis 05',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: 'a82f73c5-9ba1-4ded-bea2-93c3f88d2d2c',
                          actions: [
                            {
                              _id: 'f91ffd68-59ce-4d5d-b56b-45269008c9c0',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Boh 800',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Boh 800',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/boh_800.jpg',
                          name: 'Boh 800',
                          text: 'Boh 800',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '03cfe2d8-ec98-4de9-b328-be6da6cfa93d',
                          actions: [
                            {
                              _id: '24419bca-2f13-44b9-a447-6a574a9610e3',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Mag 7026',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Mag 7026',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_7026.jpg',
                          name: 'Mag 7026',
                          text: 'Mag 7026',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                        {
                          _id: '7476a7a2-67c1-4de3-8687-62b69c15849f',
                          actions: [
                            {
                              _id: '8e56a942-bf71-4dae-88c7-4375b88742b4',
                              functionName: 'setMaterialByObjectPrefixMaterialName',
                              prefix: 'fabric_bottom',
                              materialName: 'Mag 5001',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_ARMREST',
                              value: 'CATEGORY_C',
                            },
                            {
                              functionName: 'setSystemVariable',
                              name: 'UPHOLSTERY_LABEL',
                              value: 'Mag 5001',
                            },
                          ],
                          controlType: 'imageButton',
                          imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/mag_5001.jpg',
                          name: 'Mag 5001',
                          text: 'Mag 5001',
                          classes: ['virtenzo-panel-button'],
                          href: '',
                          groups: 'Upholstery',
                        },
                      ]
                    }
                  ],
                },
              ]
            }
          ],
        },
      ],
      queryConfig: true,
      selector: "virtenzo-panel"
    }
  }
}